import React from 'react';
import { getFromStorage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import LandingHome from './LandingHome';
import DashboardHome from './DashboardHome';

/**
 * Guest: marketing landing. Logged-in: dashboard home (hero, trending, reviews).
 */
function Home() {
  const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN });
  if (token) {
    return <DashboardHome />;
  }
  return <LandingHome />;
}

export default Home;
